import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'root-primecap',
  templateUrl: './primecap-view.component.html'
})
export class PrimecapComponent implements OnInit, AfterViewInit{
  isResponsive = false;
  constructor(private breakpointObserver: BreakpointObserver){
  }
  ngOnInit(): void {
    this.verificarResponsividade()
  }

  ngAfterViewInit(): void {
    this.verificarResponsividade()
  }

  private verificarResponsividade(){
    this.breakpointObserver.observe(['(max-width:935px)']).subscribe(res=>{
      this.isResponsive = res.matches;
    })
  }
}
